import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { hideIncompleteRow } from 'core/utils/helpers/hideIncompleteRow';
import { selectWidthMQ } from 'core/modules/MediaQueries/selectors';

export const useHideIncompleteRow = (shouldHideIncompleteRow, hasCarousel, listRef) => {
  const widthMQ = useSelector(selectWidthMQ);

  useEffect(() => {
    if (shouldHideIncompleteRow && !hasCarousel && listRef.current) {
      hideIncompleteRow(listRef.current);
    }
  }, [widthMQ, listRef]);
};
